import { Snackbar } from "@material-ui/core";

export default function GlobalSnackbar(props: { message: any, open: boolean }) {
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={props.open}
        >
            {props.message}
        </Snackbar>
    );
}